import { useSelector } from 'react-redux'

import { routeFor } from '@/utils/router'
import { translate } from '@/utils/translations'

const BookshelfLoginLink = () => {
  const eReaderUrl = useSelector(state => state.currentRegion.eReaderUrl)

  return (
    <div className='u-push--top'>
      <p>
        {translate('courseware_no_login_url.part_one')}
        {' '}
        <a
          className='link--branded'
          data-testid='Bookshelf Link'
          href={eReaderUrl || routeFor('bookshelf')}
        >
          {translate('account_center.bookshelf')}
        </a>
        {' '}
        {translate('courseware_no_login_url.part_two')}
      </p>
    </div>
  )
}

export default BookshelfLoginLink
